import React from 'react'
import { motion } from "framer-motion";
import Header from '../component/Header'
import bg from '../rings.png'
import introthum from '../introImg.jpeg'
import VisionandMission from '../component/VisionandMission';
import Footer from '../component/Footer';
import Achivment from '../component/Achivment';
import Faq from '../component/Faq';
// import VisionandMission from '..'

export default function About() {
    return (
        <div>
            <Header />
            <div className="relative h-[320px] md:h-[400px] flex items-center justify-center overflow-hidden">

                {/* Background Image */}
                <div
                    className="absolute inset-0 bg-cover bg-no-repeat bg-fixed"
                    style={{ backgroundImage: `url(${bg})` }}
                />

                {/* Dark Overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-[#172f47]/100 to-[#12253c]/70" />

                {/* Animated Glow */}
                <div className="absolute w-[400px] h-[400px] bg-blue-400/20 rounded-full blur-3xl animate-pulse top-[-120px] left-[-120px]" />
                <div className="absolute w-[300px] h-[300px] bg-orange-400/20 rounded-full blur-3xl animate-pulse bottom-[-100px] right-[-100px]" />

                {/* Content */}
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="relative z-10 text-center px-6"
                >
                    {/* Title */}
                    <motion.h1
                        initial={{ opacity: 0, scale: 0.9 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.2 }}
                        className="text-3xl sm:text-4xl md:text-5xl font-bold text-white"
                    >
                        About <span className="text-[#00bd86]">US</span>
                    </motion.h1>

                    {/* Subtitle */}
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4 }}
                        className="mt-4 text-gray-200 text-sm sm:text-base max-w-xl mx-auto"
                    >
                        Transforming Lending for the Digital Age{" "}
                        {/* <span className="text-orange-400 font-semibold">
                            Your Company Name
                        </span> */}
                    </motion.p>
                </motion.div>
            </div>
            <section className="bg-gray-100 py-20 px-4">
                <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

                    {/* Left Image */}
                    <motion.div
                        initial={{ opacity: 0, x: -80 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                        className="relative"
                    >
                        <img
                            src={introthum}
                            alt="About"
                            className="rounded-2xl w-full h-auto object-cover"
                        />

                        {/* Badge */}
                        {/* <div className="absolute bottom-5 left-5 bg-[#0fce84] text-white px-6 py-4 rounded-xl shadow-lg">
                            <h2 className="text-2xl font-bold">5+</h2>
                            <p className="text-xs uppercase">Years of Excellence</p>
                        </div> */}
                    </motion.div>

                    {/* Right Content */}
                    <motion.div
                        initial={{ opacity: 0, x: 80 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        <p className=" uppercase font-semibold text-lg mb-2 " style={{ color: '#0fce84 ' }}>
                            About Company
                        </p>

                        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-snug mb-4">
                            Advancing the Future of Digital Lending
                        </h2>

                        <p className="text-gray-600 mb-4 leading-7">
                            At LNVS Fintech, we started with a simple belief - financial services should work for businesses, not against them. We're a fintech company built to make digital lending faster, safer, and genuinely easier for the businesses that depend on it.
                        </p>

                        <p className="text-gray-600 mb-4 leading-7">From KYC verification to payment solutions and lending platforms, we've put everything under one roof - so you're not juggling five different tools to get one thing done. Our APIs are built to grow with you, whether you're processing your first loan or your ten-thousandth.</p>
                        <p className="text-gray-600 mb-4 leading-7">We won't pretend the gap between traditional finance and modern technology is small - but closing it is exactly what we do every day. No unnecessary complexity, no slow approvals, no friction.</p>
                        <p className="text-gray-600 mb-4 leading-7">Just reliable technology backed by people who actually care about where your business is headed.</p>




                    </motion.div>

                </div>
            </section>

            <VisionandMission />
            <Achivment />
            <Faq />
            <Footer />

        </div>
    )
}
